import api, { createApiService } from "../http"
import { GetAllContractsResponse, IContract } from "../types/services-types/contract-types"
import { RequestGetAll } from "../types/services-types/http-types"

export default class ContractService {

    static apiContractService = createApiService('/contract')


    static async Create(formData: FormData) {
        const response = await this.apiContractService.post<IContract>(`/create`, formData)
        return response.data
    }

    static async CreatePersonalInformation(formData: FormData) {
        const response = await this.apiContractService.post<IContract>(`/create-personal-information`, formData)
        return response.data
    }

    static async Get(id: number | string) {
        const response = await this.apiContractService.get<IContract>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: string | number, page: string | number) {
        const response = await this.apiContractService.get<RequestGetAll<IContract[]>>(`/all`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllUser(id: number, limit: string | number, page: string | number) {
  const response = await this.apiContractService.get<RequestGetAll<IContract[]>>(`/all-user/${id}`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiContractService.get<number>(`/delete/${id}`, {
        })
        return response.data
    }
}